export default __webpack_public_path__ + "static/media/77_Agent_Thonburi_header_order.e0ce36a4.png";